export const ASSISTANCE_TYPE_TOWING = "towing";
export const ASSISTANCE_TYPE_BATTERY = "battery";
export const ASSISTANCE_TYPE_GAS = "gas";
export const ASSISTANCE_TYPE_LOCKSMITH = "locksmith";
export const ASSISTANCE_TYPE_TIRE = "tire";
export const ASSISTANCE_TYPE_OTHER = "other";

export const ASSISTANCE_STATUS_PENDING = "pending";
export const ASSISTANCE_STATUS_ACCEPTED = "accepted";
export const ASSISTANCE_STATUS_ON_ROAD = "on_road";
export const ASSISTANCE_CANCELED = "canceled";
export const ASSISTANCE_FINISHED = "finished";
export const ASSISTANCE_REJECTED = "rejected";

export const VEHICLE_UBICATIONS = [
  {
    label: "En la calle",
    value: "En la calle",
  },
  {
    label: "En una planta alta",
    value: "En una planta alta",
  },
  {
    label: "Subsuelo o sótano",
    value: "Subsuelo o sótano",
  },
  {
    label: "Autopista",
    value: "Autopista",
  },
];

export const AssistanceDetails: any = {
  VEHICLE_STOPPED_WHILE_DRIVING: "vehicle_stopped_while_driving",
  VEHICLE_WONT_START: "vehicle_wont_start",
  NO_SPARE_TIRE: "no_spare_tire",
  SPARE_TIRE: "spare_tire",
};
